/**
 * apiSpCallWithToken.js
 * Utility updated to route through our secure local ASP.NET Core proxy server.
 * Authentication headers and redirect following are managed entirely on the backend.
 */
import axios from 'axios';
import {AppResource} from '@config/config'
/**
 * Handles error reporting for local proxy execution loops.
 */
const handleSpResponseErrors = (apiClient, error) => {
    console.error("Local Proxy Error Branch Target:", apiClient.defaults.baseURL, error);
    return Promise.reject(error);
};

/**
 * Creates an Axios instance targeting your ASP.NET Core proxy path wrapper.
 * @param {string} url - Overridden dynamically or defaults to your internal server proxy base.
 */
export const apiSpCallWithToken = (url) => {
    // Fall back automatically to your local backend development route if a fragment isn't provided
    const targetBaseUrl = url || AppResource.appserver_url;

    const apiClient = axios.create({
        baseURL: targetBaseUrl,
        timeout: 45000, // Elevated buffer window to account for server-to-server redirection streaming 
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        }
    });

    // Request Interceptor: Simply monitors traffic and confirms routing logic paths
    apiClient.interceptors.request.use(
        (config) => {
            console.log("Routing Request via Internal App Proxy:", config.baseURL + config.url);
            return config;
        },
        (error) => Promise.reject(error)
    );

    // Response Interceptor: Catches issues upstream and simplifies standard payload error bubbles
    apiClient.interceptors.response.use(
        (response) => response,
        (error) => handleSpResponseErrors(apiClient, error)
    );

    return apiClient;
};